import React, { useState, useEffect, useReducer, useRef } from "react";
import { Popup, Position } from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import * as actions from "../../../actions/dle";
import DleReducer from "../../../reducers/dle";
import SelectBox from "devextreme-react/select-box";
import DateBox from "devextreme-react/date-box";
import NumberBox from "devextreme-react/number-box";
import Button1 from "devextreme-react/button";
import { alert } from "devextreme/ui/dialog";
import ReasonCodeEntry from "./ReasonCodeEntry";
import moment from "moment";
import DataGrid, {
  Column,
  Editing,
  Paging,
  Scrolling,
  Lookup,
  RequiredRule,
} from "devextreme-react/data-grid";
import { postUserLog } from "../../../actions/common";
const initState = {
  shiftDetails: null,
  dleReasons: [],
  refreshDle: null,
  prevDLEData: [],
};
export default ({ siteId, tierId, closeDI, navigationOn }) => {
  const [state, dispatch] = useReducer(DleReducer, initState);
  let { shiftDetails, dleReasons, refreshDle, prevDLEData } = state;
  const [activeShift, setActShift] = useState(0);
  const [shiftLst, setShiftLst] = useState([]);
  const [gridInfo, setGridInfo] = useState([]);
  const [dleDate, setDleDate] = useState(new Date());
  const [eHr, setEHr] = useState(null);
  const [pHr, setPHr] = useState(null);
  const [btnDisabled, setBtnDisble] = useState(false);
  const [target, setTarget] = useState(null);
  const [shiftDle, setShiftDle] = useState(null);
  const [andonClr, setClrCode] = useState("#666");
  const [isCurrentDate, setIsCurrentDate] = useState(true);
  const [arrShiftData, setArrShiftData] = useState([]);
  const [dleReasonData, setDleReasonData] = useState([]);

  const handleIsCurrentDate = (dleDate) => {
    let currentDate = moment(new Date()).format("YYYY-MM-DD");
    if (currentDate === dleDate) {
      setIsCurrentDate(true);
    } else {
      setIsCurrentDate(false);
    }
  };

  const dleResonGrid = useRef(null);

  useEffect(() => {
    actions.fetchDleResons(dispatch, tierId);
  }, []);

  useEffect(() => {
    if (dleDate) {
      setArrShiftData([]);
      let dateVal = dleDate && moment(dleDate).format("YYYY-MM-DD");
      handleIsCurrentDate(dateVal);
      actions.fetchShifts(
        dispatch,
        `${siteId}&tierId=${tierId}&isStdDay=true&date=${dateVal}`
      );
    }
  }, [dleDate]);

  useEffect(() => {
    if (refreshDle) {
      closeDI(false);
    }
  }, [refreshDle]);

  useEffect(() => {
    if (shiftDetails && shiftDetails.shifts) {
      let shiftNo = [];
      for (let i = 0; i < shiftDetails.quantity; i++) {
        let j = i + 1;
        shiftNo.push({ k: "Shift " + j, id: j });
      }
      setShiftLst(shiftNo);
      setActShift(1);
      setTarget(shiftDetails.dleTarget ? shiftDetails.dleTarget : null);
    }
  }, [shiftDetails]);

  const onSave = () => {
    if (activeShift < 1) {
      alert("Please select a Shift.", "Alert");
      return;
    }
    if (!eHr) {
      alert("Please enter Earned hour.", "Alert");
      return;
    }
    if (!pHr) {
      alert("Please enter Paid hour.", "Alert");
      return;
    }
    let reasons = [],
      isReasonValid = true;
    if (eHr && pHr) {
      let sDle = (eHr / pHr) * 100;

      if (sDle < target) {
        //let data = dleResonGrid.current.instance.getVisibleRows();
        dleReasonData.map((v) => {
          let d = v;
          let id = d.reasonCodeId ? d.reasonCodeId : null;
          let qty = d.qty ? d.qty : 0;
          let reasonId = d.id ? d.id : 0;

          // if (id && qty)

          if (id) {
            reasons.push({
              id: reasonId,
              reasonCodeId: id,
              comment: d.comment ? d.comment : "",
              qty: qty,
            });
          } else {
            isReasonValid = false;
            alert("Please fill all mandatory fields.", "Alert");
          }
        });

        if (reasons.length < 1) {
          alert(
            "No reason was mentioned for why DLE % didn't meet the shift target. Please add reason.",
            "Alert"
          );
          isReasonValid = false;
        }

        // if (
        //   pHr - eHr !==
        //   dleReasonData.reduce((accum, item) => accum + item.qty, 0)
        // ) {
        //   alert("Missed Quantity does not match.", "Alert");
        //   isReasonValid = false;
        // }
      }
    }
    if (!isReasonValid) return;
    let payload = {
      dleid: 0,
      shift: activeShift,
      date: moment(dleDate).format("YYYY-MM-DD"),
      earnedHour: eHr,
      paidHour: pHr,
      reasons: reasons,
      tierId: tierId,
      section: navigationOn,
    };

    actions.addDailyInput(dispatch, payload);
    setBtnDisble(true);
  };

  const onDLEDateChange = (dateVal) => {
    setDleDate(dateVal);
    handleIsCurrentDate(moment(dateVal).format("YYYY-MM-DD"));
  };

  const onShiftValueChange = (shiftVal) => {
    setActShift(shiftVal);
    dleDate && handleIsCurrentDate(moment(dleDate).format("YYYY-MM-DD"));
  };

  useEffect(() => {
    if (activeShift > 0) {
      let dateVal = dleDate && moment(dleDate).format("YYYY-MM-DD");
      let dleObj = {
        shiftID: activeShift,
        tierID: tierId,
        isStdDay: true,
        dleDate: dateVal,
        dleID: 1,
      };
      actions.fetchDLEDetails(dispatch, dleObj);
    }
  }, [dleDate, activeShift]);

  useEffect(() => {
    if (
      prevDLEData &&
      prevDLEData.shiftInfo &&
      prevDLEData.shiftInfo.length > 0 &&
      arrShiftData
    ) {
      let newShiftData = [];

      shiftLst &&
        shiftLst.map((s) => {
          const dat = prevDLEData.shiftInfo.find((ob) => ob.shift === s.id);
          newShiftData.push(dat ? dat : { shift: s.id, shiftTarget: 0 });
        });
      setArrShiftData(newShiftData);
    } else if (
      prevDLEData &&
      prevDLEData.shiftInfo &&
      prevDLEData.shiftInfo.length === 0 &&
      arrShiftData
    ) {
      let newShiftData = [];
      shiftLst &&
        shiftLst.map((s) => {
          newShiftData.push({ shift: s.id, shiftTarget: 0 });
        });
      setArrShiftData(newShiftData);
    }

    if (
      prevDLEData &&
      prevDLEData.dleid > 0 &&
      prevDLEData.shift == activeShift
    ) {
      setGridInfo(prevDLEData.reasons ? prevDLEData.reasons : []);
      setEHr(prevDLEData.earnedHour);
      setPHr(prevDLEData.paidHour);
    } else if (prevDLEData && prevDLEData.dleid == null) {
      setGridInfo(prevDLEData.reasons ? prevDLEData.reasons : []);
      setEHr(null);
      setPHr(null);
      setShiftDle(null);
    }
  }, [prevDLEData]);

  useEffect(() => {
    if (
      eHr &&
      pHr &&
      arrShiftData &&
      activeShift &&
      prevDLEData?.shift === activeShift
    ) {
      if (prevDLEData?.dleid != null) {
        let isChangeEHR =
          prevDLEData?.earnedHour != eHr && prevDLEData?.shift === activeShift;
        let isChangePHR =
          prevDLEData?.paidHour != pHr && prevDLEData?.shift === activeShift;
        if (isChangeEHR || isChangePHR) {
          let sDle = (eHr / pHr) * 100;
          if (sDle >= target) setClrCode("#48ff00");
          else if (sDle < target) setClrCode("red");
          setShiftDle(sDle);
          arrShiftData.find((ob) => {
            if (ob.shift === activeShift) ob.shiftTarget = sDle;
          });
        } else {
          let newShiftData = [];
          shiftLst &&
            shiftLst.map((s) => {
              const dat = prevDLEData?.shiftInfo?.find(
                (ob) => ob.shift === s.id
              );
              newShiftData.push(dat ? dat : { shift: s.id, shiftTarget: 0 });
            });
          setArrShiftData(newShiftData);
        }
      } else {
        let sDle = (eHr / pHr) * 100;
        if (sDle >= target) setClrCode("#48ff00");
        else if (sDle < target) setClrCode("red");
        setShiftDle(sDle);
        arrShiftData.find((ob) => {
          if (ob.shift === activeShift) ob.shiftTarget = sDle;
        });
      }
    } else if (
      eHr &&
      pHr &&
      arrShiftData &&
      activeShift &&
      prevDLEData?.shift === null
    ) {
      let sDle = (eHr / pHr) * 100;
      if (sDle >= target) setClrCode("#48ff00");
      else if (sDle < target) setClrCode("red");
      setShiftDle(sDle);
      arrShiftData.find((ob) => {
        if (ob.shift === activeShift) ob.shiftTarget = sDle;
      });
    } else {
      let newShiftData = [];
      shiftLst &&
        shiftLst.map((s) => {
          const dat = prevDLEData?.shiftInfo?.find((ob) => ob.shift === s.id);
          newShiftData.push(dat ? dat : { shift: s.id, shiftTarget: 0 });
        });
      setArrShiftData(newShiftData);
    }
  }, [eHr, pHr, activeShift]);

  function reasonCodeDisp(item) {
    return item && `${item?.level0} - ${item?.value}`;
  }

  return (
    <div className="dle-input">
      {shiftLst && target && (
        <Popup
          visible={true}
          onHiding={() => closeDI(false)}
          dragEnabled={true}
          showCloseButton={true}
          showTitle={true}
          title="Daily input"
          width={"70%"}
          height={"auto"}
          resizeEnabled={true}
        >
          <ScrollView width="100%" height="100%" className="fpy-content">
            <Position at="center" my="center" />
            <div>
              {target && (
                <div style={{ marginRight: "10px" }}>
                  <div className="flx-spc-btn">
                    <SelectBox
                      width={"23%"}
                      dataSource={shiftLst}
                      onValueChanged={(v) => {
                        onShiftValueChange(v.value);
                        postUserLog({
                          event: `Daily Input Screen Shift Selection`,
                          data: {
                            action: `Shift ${v.value} selected`,
                            module: "Digital Tier",
                            section: navigationOn,
                            siteUId: siteId,
                            widget: "Cost Metric: DLE",
                            tierId: tierId,
                          },
                        });
                      }}
                      valueExpr="id"
                      displayExpr="k"
                      value={activeShift}
                      placeholder="Select Shift"
                    />
                    <DateBox
                      width={"23%"}
                      className="fpy-datebox"
                      value={dleDate}
                      onValueChanged={(e) => {
                        onDLEDateChange(e.value);
                        postUserLog({
                          event: `Daily Input Screen Date Selection`,
                          data: {
                            action: `${moment(e.value).format(
                              "YY-MM-DD"
                            )} date selected`,
                            module: "Digital Tier",
                            section: navigationOn,
                            siteUId: siteId,
                            widget: "Cost Metric: DLE",
                            tierId: tierId,
                          },
                        });
                      }}
                      type="date"
                      useMaskBehavior={true}
                      min={
                        shiftDetails?.initialDate
                          ? new Date(shiftDetails?.initialDate)
                          : new Date()
                      }
                      max={new Date()}
                    />
                    <div className="dx-field fpy-target">
                      <b>Target</b>
                      <Button1
                        readOnly={true}
                        style={{ marginLeft: "4px", pointerEvents: "none" }}
                        onClick={() => {}}
                        text={target + " %"}
                        type="normal"
                      />
                    </div>{" "}
                  </div>
                  <div className="flx-spc-btn" style={{ marginTop: "10px" }}>
                    <div className="dx-field" style={{ width: "38%" }}>
                      <NumberBox
                        className="dx-field-value"
                        label="Earned Hours *"
                        labelMode="floating"
                        value={eHr}
                        onValueChanged={(e) => setEHr(e.value)}
                        format="#0.##"
                        min={0}
                      ></NumberBox>
                    </div>
                    <div
                      className="dx-field"
                      style={{ width: "38%", marginLeft: "14px" }}
                    >
                      <NumberBox
                        className="dx-field-value"
                        label="Paid Hours *"
                        labelMode="floating"
                        value={pHr}
                        onValueChanged={(e) => setPHr(e.value)}
                        min={1}
                        format="#0.##"
                      ></NumberBox>
                    </div>
                    <div style={{ width: "60%" }}>
                      {arrShiftData &&
                        arrShiftData.length > 0 &&
                        arrShiftData.map((data) => (
                          <>
                            <div className="dle-sadn">
                              <div>Shift {data.shift}</div>
                              <div>
                                <span
                                  className="andon"
                                  style={{
                                    background:
                                      data.shiftTarget >= target
                                        ? "#48ff00"
                                        : data.shiftTarget < target &&
                                          data.shiftTarget != 0
                                        ? "red"
                                        : "#666",
                                  }}
                                >
                                  {" "}
                                </span>
                              </div>
                              <div style={{ width: "60px" }}>
                                {Number(data.shiftTarget).toFixed(2) + "%"}
                              </div>
                            </div>
                          </>
                        ))}
                    </div>
                  </div>
                  <div>
                    {/* <DataGrid
                    ref={dleResonGrid}
                    id="dleReason"
                    dataSource={gridInfo}
                    rowAlternationEnabled={true}
                    showBorders={true}
                  >
                    <Scrolling mode="virtual" showScrollbar="always" />
                    <Paging enabled={false} />
                    <Editing
                      mode="cell"
                      allowUpdating={true}
                      allowDeleting={true}
                      allowAdding={true}
                      useIcons={true}
                    />

                    <Column dataField="reasonId" caption="Reason Code">
                      <Lookup
                        dataSource={dleReasons}
                        valueExpr="id"
                        displayExpr={reasonCodeDisp}
                      />
                      <RequiredRule />
                    </Column>
                    <Column dataField="comment" caption="Comment"></Column>
                  </DataGrid> */}

                    <ReasonCodeEntry
                      setReasonData={setDleReasonData}
                      tierId={tierId}
                      reasonsData={gridInfo}
                      earnedHour={eHr}
                      paidHour={pHr}
                      target={target}
                      eHr={eHr}
                      pHr={pHr}
                    />
                  </div>
                </div>
              )}
            </div>
            <div>
              {shiftDetails && !target && (
                <div>
                  <h2>Please have Tier Owner/Alternate set Target % first</h2>
                </div>
              )}
            </div>
            {target && (
              <div className="cbtn">
                <Button1
                  style={{ marginRight: "14px" }}
                  disabled={btnDisabled}
                  onClick={onSave}
                  text="Save"
                  type="normal"
                />{" "}
              </div>
            )}
          </ScrollView>
        </Popup>
      )}
    </div>
  );
};
